'use strict';

// BREAD PLACEMENT SETUP
const pdpPlacementPreQual = {
    financingType: 'card',
    locationType: 'product',
    placementId: '20ac5a7b-2c25-468d-9a9c-171cd9bc7865',
    domID: 'bread-payments-pdp-prequal'
};

const pdpPlacementApply = {
    financingType: 'card',
    locationType: 'product',
    placementId: '96e5c510-87fd-4439-b6ad-507010b815ba',
    domID: 'bread-payments-pdp-apply'
};

const cartPlacementPrequal = {
    financingType: 'card',
    locationType: 'cart',
    placementId: '5106caf4-f11f-4259-9574-20df9d5c2acb',
    domID: 'bread-payments-cart-prequal'
};

const cartPlacementApply = {
    financingType: 'card',
    locationType: 'cart',
    placementId: '8e62c7c4-e95a-40e6-bce1-4dbdc3169dac',
    domID: 'bread-payments-cart-apply'
};

const checkoutPlacementPrequal = {
    financingType: 'card',
    locationType: 'checkout',
    placementId: 'e6769261-561d-44a0-a195-27e707457d87',
    domID: 'bread-payments-checkout-prequal'
};

const checkoutPlacementApply = {
    financingType: 'card',
    locationType: 'checkout',
    placementId: '815859a1-123f-4ec3-9731-ccf4eac0e22c',
    domID: 'bread-payments-checkout-apply'
};

const checkoutPlacementAccountLookup = {
    financingType: 'card',
    locationType: 'checkout',
    placementId: 'f77b4c5b-4b27-48b6-8074-b0e67ff080dc',
    domID: 'bread-payments-account-lookup'
};

/**
 * Get location type for RTPS
 * @returns {string} locationType
*/
function getBreadLocationType() {
    const path = window.location.pathname.toLowerCase();

    if (path.includes('checkout')) {
        return 'checkout';
    }

    if (path.includes('cart')) {
        return 'cart';
    }

    if (path.includes('pro-credit-card')) {
        return 'landing';
    }

    if (path.includes('products')) {
        return 'product';
    }

    return 'homepage';
}

const hasBreadPayments = typeof BreadPayments !== 'undefined';
if (hasBreadPayments) {
    const isProduction = $('.bread-button-wrapper-row').data('production') || $('.bread-env').data('production');

    // eslint-disable-next-line no-undef
    BreadPayments.setup({
        env: isProduction ? 'PROD' : 'STAGE' // 'STAGE' or 'PROD' defaults to 'PROD
    });

    // eslint-disable-next-line no-undef
    BreadPayments.registerPlacements([
        pdpPlacementPreQual,
        pdpPlacementApply,
        cartPlacementPrequal,
        cartPlacementApply,
        checkoutPlacementPrequal,
        checkoutPlacementApply,
        checkoutPlacementAccountLookup
    ]);

    // eslint-disable-next-line no-undef
    BreadPayments.on('CARD:RECEIVE_PREQUAL_APPLICATION_RESULT', (cardResult) => {
        // Handle Application Submitted
        if (cardResult.callId) {
            const url = $('#proCreditCardModal').data('plcc-url') || $('.bread-prescreen-container').data('plcc-url');
            $.ajax({
                url: url + `?breadTokenId=${cardResult.callId}`,
                method: 'get'
            });
        }
    });

    // eslint-disable-next-line no-undef
    BreadPayments.on('CARD:RECEIVE_PRESCREEN_APPLICATION_RESULT', (cardResult) => {
        // Handle Application Submitted
        if (cardResult.callId) {
            const url = $('#proCreditCardModal').data('plcc-url') || $('.bread-prescreen-container').data('plcc-url');
            $.ajax({
                url: url + `?breadTokenId=${cardResult.callId}`,
                method: 'get'
            });
        }
    });
    // eslint-disable-next-line no-undef
    BreadPayments.on('CARD:RECEIVE_APPLICATION_RESULT', (cardResult) => {
        // Handle Application Submitted
        if (cardResult.callId) {
            const url = $('#proCreditCardModal').data('plcc-url') || $('.bread-prescreen-container').data('plcc-url');
            $.ajax({
                url: url + `?breadTokenId=${cardResult.callId}`,
                method: 'get'
            });
        }
    });

    // eslint-disable-next-line no-undef
    BreadPayments.on('CARD:RECEIVE_ACCOUNT_EXISTS', (acctResult) => {
        if (acctResult) {
            $.ajax({
                url: $('#bread-payments-account-lookup').data('plcc-url') + `?breadTokenId=${acctResult.callId}`,
                method: 'get'
            });
        }
    });

    // eslint-disable-next-line no-undef
    BreadPayments.on('CARD:CLOSE_OVERLAY', () => {
        if (window.location.pathname.includes('checkout')) {
            window.location.reload();
        }
    });


    const breadRTPSSubmitted = 'BREAD-RTPS-SUBMITTED';
    const breadRTPSPresented = 'BREAD-RTPS-PRESENTED';

    // Emitted when a customer responds to their rt prescreen offer
    // eslint-disable-next-line no-undef
    BreadPayments.on('CARD:OFFER_RESPONSE', () => {
        localStorage.setItem(breadRTPSPresented, 'true');
    });

    var customerGroups = document.cookie.split(';').find(cookie => cookie.trim().toLowerCase().startsWith('customergroups'));
    const isLoggedIn = customerGroups && customerGroups.toLowerCase().includes('registered');

    if (isLoggedIn && !localStorage.getItem(breadRTPSPresented) && !localStorage.getItem(breadRTPSSubmitted)) {
        try {
            $.ajax({
                url: '/on/demandware.store/Sites-gamestop-us-Site/default/Account-Info',
                method: 'GET',
                success: function (data) {
                    if (data && data.buyer) {
                        const buyer = data.buyer;
                        const address = buyer && buyer.billingAddress;

                        if (buyer && address) {
                            const config = {
                                loyaltyID: data.loyaltyID,
                                env: isProduction ? 'PROD' : 'STAGE',
                                storeNumber: data.storeNumber,
                                buyer: {
                                    givenName: buyer.givenName,
                                    familyName: buyer.familyName,
                                    birthDate: buyer.birthDate,
                                    email: buyer.email,
                                    phone: buyer.phone,
                                    billingAddress: {
                                        address1: address.address1,
                                        address2: address.address2,
                                        country: address.country,
                                        locality: address.locality,
                                        region: address.region,
                                        postalCode: address.postalCode
                                    }
                                }
                            };


                            // eslint-disable-next-line no-undef
                            BreadPayments.setup(config);

                            // eslint-disable-next-line no-undef
                            BreadPayments.submitRtps({
                                financingType: 'card',
                                locationType: getBreadLocationType()
                            });

                            localStorage.setItem(breadRTPSSubmitted, 'true');
                        }
                    }
                }
            });
        } catch (e) {}
    }
}
